module.exports = __webpack_public_path__ + "static/media/explore_illustration.4cf623db.svg";